import css from 'styled-jsx/css';

const styles = css.global`#rastreadores-parcerias {
  position: relative;
}

.box-parcerias {
  background-color: #fff;
  z-index: 1;
  position: relative;
}

.container-parcerias {
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.parcerias-div-1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.div-1-images {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.logo-ituran {
  width: 132px;
  height: 71px;
}

.div-carros-parcerias {
  position: relative;
  height: 112px;
}

.carro-1 {
  z-index: 2;
  position: absolute;
  left: calc(50% - 150px);
  bottom: 0;
  height: 116px;
  object-fit: contain;
}

.carro-2 {
  z-index: 1;
  position: absolute;
  right: calc(50% - 140px);
  bottom: 0;
  height: 110px;
  object-fit: contain;
}

.div-1-texts {
  display: flex;
  flex-direction: column;
  gap: 17px;
  max-width: 437px;
}

.div-1-texts .title {
  font-family: SantanderHeadline;
  font-size: 20px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  color: #000000;
  margin: 0;
}

.div-1-texts .description {
  font-family: SantanderText;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
}

.div-1-texts .description .font-18 {
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
  color: #cc0000;
}

.div-1-texts .description b {
  font-size: 16px;
  font-weight: 600 !important;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
  color: #cc0000;
}

.parcerias-div-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.div-2-title {
  font-family: SantanderHeadline;
  font-size: 20px;
  font-weight: 900;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
  color: #000000;
  margin: 0;
}

.div-2-card-ctns {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.div-2-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 263px;
  height: 183px;
  padding: 14px 16px;
  border: 1px solid #767676;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 5px;
  background-color: #fff;
}

.div-2-card.card-duas-linhas .card-list {
  height: 80px;
  justify-content: flex-start;
}

.card-title {
  font-family: SantanderText;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  margin: 0;
}

.card-list {
  display: flex;
  flex-direction: column;
  font-family: SantanderText;
  font-size: 15px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  color: #000000;
  height: 100px;
  justify-content: center;
  list-style-type: none;
}

.bolinhas-parcerias,
.background-parcerias {
  display: none;
}

@media (min-width: 992px) {
  #rastreadores-parcerias {
    background-color: #cc0000;
    height: 755px;
    padding-top: 33px;
    padding-bottom: 77px;
  }

  .box-parcerias {
    height: 663px;
    width: 90%;
    padding: 40px;
    padding-top: 26px;
    border-radius: 0 3px 3px 0;
    box-shadow: 0px 2px 8px 0px #22222266;
    border: 3px solid #ffffff;
  }

  .container-parcerias {
    max-width: 1145px;
    width: 100%;
    gap: 38px;
    margin-left: auto;
  }

  .parcerias-div-1 {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  .div-1-images {
    gap: 39px;
  }

  .div-carros-parcerias {
    height: 202px;
    padding: 0;
  }

  .carro-1 {
    height: 202px;
    left: 0;
  }

  .carro-2 {
    height: 200px;
    right: auto;
    left: 215px;
  }

  .div-1-texts {
    max-width: 367px;
    width: 100%;
  }

  .div-1-texts .title {
    font-size: 32px;
    line-height: 36px;
    letter-spacing: 0px;
    text-align: left;
  }

  .div-1-texts .description {
    font-family: SantanderText;
    font-size: 20px;
    line-height: 28px;
  }

  .div-1-texts .description .font-18 {
    font-size: 32px;
    line-height: 28px;
  }

  .div-1-texts .description b {
    font-size: 20px;
    line-height: 28px;
  }

  .parcerias-div-2 {
    gap: 32px;
    width: 100%;
  }

  .div-2-title {
    font-size: 24px;
    line-height: 35px;
  }

  .div-2-card-ctns {
    flex-direction: row;
    gap: 23px;
    justify-content: space-between;
    width: 100%;
  }

  .div-2-card {
    max-width: 372px;
    width: 100%;
    height: 150px;
    padding: 14px 8px;
    gap: 0;
  }

  .background-parcerias {
    z-index: 0;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #990000;
    width: 98%;
    height: 712px;
  }

  .card-list {
    font-size: 17px;
  }

  .bolinhas-parcerias {
    z-index: 2;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    background-image: url(assets/rastreadores/bolinhas-parcerias.png);
    background-repeat: no-repeat;
    background-size: contain;
    height: 357px;
    width: 130px;
  }
}
`;

export default styles;